<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {Primitive, type PrimitiveProps} from 'radix-vue'
import {type ButtonVariants, buttonVariants} from '.'
import {cn} from '@/lib/utils'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  as?: string
  class?: HTMLAttributes['class']
  pending?: ButtonVariants['pending'],
  to?: any //@todo Find right type
}

const emit = defineEmits(['click'])
const props = withDefaults(defineProps<Props>(), {
  as: 'button',
})
const onClick = (e: any) => {
  if (props.to) {
    navigateTo(props.to)
  }
  emit('click', e)
}
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :disabled="pending"
    :class="cn(buttonVariants({ variant, size, pending }), props.class)"
    @click="onClick"
  >
    <span
      v-if="variant === 'icon'"
      class="btn-bg absolute z-[-1] top-1/2 left-1/2 w-9 h-9 rounded-full bg-gray-dark transform -translate-x-1/2 -translate-y-1/2 scale-0 [@media(hover:hover)]:group-hover:scale-100 transition-transform duration-150"></span>
    <span
      v-if="variant === 'counter'"
      class="btn-bg absolute z-[-1] top-1/2 left-1/2 w-full h-9 rounded-[18px] bg-gray-dark transform -translate-x-1/2 -translate-y-1/2 scale-0 [@media(hover:hover)]:group-hover:scale-100 transition-transform duration-150"></span>
    <Icon name="line-md:loading-twotone-loop" size="22.5px" class="ml-2" v-if="pending"/>
    <slot v-else/>
  </Primitive>
</template>
